<template>
    <academic>
        <card-header :title="'Course Year: '+courseyear.title+' - '+courseyear.course.title" />
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Course Batch</p>
                <form @submit.prevent="submitForm">
                    <div class="mb-4">
                        <div class="grid grid-cols-8 gap-4 mb-4">
                            <div class="col-span-3 sm:col-span-3">
                                <breeze-label :required="true" :value="'Title'"/>
                                <breeze-input required v-model="form.title" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.title:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Status'"/>
                                <breeze-checkbox v-model="form.status" :checked="form.status" />
                                <breeze-input-error :message="form.errors?form.errors.status:''" />
                            </div>
                        </div>
                    </div>
                    <button-link :href="route('academic.courseyear.batch.list',courseyear.id)" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeTable from '@/Components/Table'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import InputCheckbox from '@/Components/InputCheckbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import { useForm } from '@inertiajs/inertia-vue3'
    import Loading from '@/Components/Loading'
    import CardHeader from '@/Components/CardHeader'

    export default {
        components: {
            Academic,
            BreezeTable,
            ButtonLink,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            InputCheckbox,
            Loading,
            SelectList,
            CardHeader
        },
        props:['courseyear','batch'],
        data(){
            return{
                form: useForm({
                    '_method':'PUT',
                    title: this.batch.title,
                    status: this.batch.status,
                }),
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('academic.courseyear.batch.update',[this.batch.id]),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            }
        },
    }
</script>
